export default "__VITE_ASSET__yJkc8KAg__"